import React, { useMemo } from "react";
import style from "./index.module.scss";

import moment from "moment";
import MessageContent from "./Components/MessageContent";
import { ChatMessageItem, MsgType } from "../../../../types";
import { FormatTime } from "../../../../polyfills";
import { useAtomValue } from "jotai";
import { userAtom } from "../../../../store";
import { makeSenderFlag } from "../../../../Utils/common";
import classNames from "classnames";

interface MessageItemProps {
    index: number;
    sessionId: string;
    message: ChatMessageItem;
    preMessage?: ChatMessageItem;
    onContextMenu(e: any): void;
}

export default function MessageItem({
    index,
    sessionId,
    message,
    preMessage,
    onContextMenu
}: MessageItemProps) {
    const { senderFlag } = useAtomValue(userAtom);

    const sendDate = useMemo(() => {
        if (index === 0) return FormatTime(message.sendDate);

        if (moment(message.sendDate).diff(preMessage?.sendDate, "minute") > 3) {
            return FormatTime(message.sendDate);
        }
        return null;
    }, [message.sendDate]);

    return (
        <div className={style.root} id={message.guid}>
            {sendDate && <div className={style.time}>{sendDate}</div>}

            {makeSenderFlag(message.sender) !== senderFlag && (
                <p className={style.senderName}>{message.sender.name}</p>
            )}

            {makeSenderFlag(message.sender) === senderFlag && (
                <p className={style.receivedName}>我</p>
            )}

            <div
                className={classNames(style.message, {
                    [style.fileMessage]: message.type === MsgType.FILE,
                    [style.send]: makeSenderFlag(message.sender) === senderFlag,
                    [style.received]:
                        makeSenderFlag(message.sender) !== senderFlag
                })}>
                <MessageContent
                    sessionId={sessionId}
                    messageId={message.guid}
                    onContextMenu={onContextMenu}
                />
            </div>
        </div>
    );
}
